import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceAddProjectExternalLinkNotificationState = createStateReducer(
  initialState,
  {
    [events.addProjectExternalLinkSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addProjectExternalLink",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.addProjectExternalLinkFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "addProjectExternalLink",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceAddProjectExternalLinkNotificationState };
